import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { PayNowButton, UnpaidFlag, isUnpaid } from "@/components/PayNowButton";

const fmtWhen = (iso) => new Date(iso).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

const ampm = (d) => {
  const h = d.getHours() % 12 || 12;
  const m = d.getMinutes();
  return `${h}${m ? `:${String(m).padStart(2, "0")}` : ""}${d.getHours() < 12 ? "am" : "pm"}`;
};

export const countdownLabel = (iso, now = new Date()) => {
  const d = new Date(iso);
  const mins = Math.round((d - now) / 60000);
  if (mins <= 0) return "Happening now";
  if (mins < 60) return `In ${mins} min`;
  if (mins < 180) { const h = Math.round(mins / 60); return `In ${h} hour${h === 1 ? "" : "s"}`; }
  const day = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const days = Math.round((day(d) - day(now)) / 86400000);
  if (days === 0) return `Today at ${ampm(d)}`;
  if (days === 1) return `Tomorrow at ${ampm(d)}`;
  if (days < 7) return `${d.toLocaleDateString("en-GB", { weekday: "long" })} at ${ampm(d)}`;
  return `In ${days} days`;
};

export function SimpleMySessions() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/me/sessions?limit=3").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);
  if (items === null) return null;
  return (
    <section className="simple-sessions" data-testid="simple-my-sessions">
      <h2 className="simple-sessions__title">My Sessions</h2>
      {items.length === 0 ? (
        <div className="simple-sessions__empty" data-testid="simple-sessions-empty">
          <p>No sessions booked yet — let&apos;s get you on court.</p>
          <div className="simple-sessions__empty-actions">
            <Link to="/find-coach" data-testid="simple-sessions-find-coach">Find a coach</Link>
            <Link to="/offerings" data-testid="simple-sessions-browse">Browse sessions</Link>
          </div>
        </div>
      ) : (
        <div className="simple-sessions__list">
          {items.map((s, i) => (
            <Link key={s.booking_id} to={`/session/${s.booking_id}`} className={`simple-session ${isUnpaid(s) ? "is-unpaid" : ""}`} data-testid={`simple-session-${s.booking_id}`}>
              <span className="simple-session__icon" aria-hidden><CalendarDays strokeWidth={1.5} /></span>
              <span className="simple-session__body">
                {i === 0 && <span className="simple-session__countdown" data-testid="simple-session-countdown">{countdownLabel(s.start)}</span>}
                <span className="simple-session__name">{s.title}</span>
                <span className="simple-session__when">{fmtWhen(s.start)}</span>
              </span>
              {isUnpaid(s) && (
                <span className="simple-session__pay">
                  <UnpaidFlag testid={`simple-session-unpaid-${s.booking_id}`} />
                  <PayNowButton bookingId={s.booking_id} price={s.price} testid={`simple-session-pay-${s.booking_id}`} />
                </span>
              )}
            </Link>
          ))}
          <Link to="/calendar?view=agenda" className="simple-sessions__all" data-testid="simple-sessions-see-all">
            See all <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      )}
    </section>
  );
}
